export { default } from "ember-stereo/helpers/stop-sound";
